import DynamicValidationService from './dynamicValidationService';
import {
  AppIdStepParameters,
  CreateValidationRequest,
  DocumentStepValue,
  IdentityTokenStepValue,
  UniquenessStepValue,
  ProcessStepRequest,
  SelfieStepParameters,
  SelfieStepValue,
  Step,
  StepResult,
  TermsStepValue,
  UserStatus,
  UserStatusRequest,
  UserStatusResult,
  Validation,
  ValidationResult,
  ValidationService,
  ValidationStatus,
  ValidationStep,
  ValidationStepStatus,
  StepValue,
} from './validationService';

const validationService: ValidationService = new DynamicValidationService();
export default validationService;

export { ValidationStep, ValidationStatus, ValidationStepStatus };
export type {
  ProcessStepRequest,
  StepResult,
  ValidationResult,
  ValidationService,
  AppIdStepParameters,
  SelfieStepParameters,
  TermsStepValue,
  IdentityTokenStepValue,
  UniquenessStepValue,
  SelfieStepValue,
  DocumentStepValue,
  CreateValidationRequest,
  Validation,
  Step,
  UserStatusRequest,
  UserStatusResult,
  UserStatus,
  StepValue,
};
